module.exports = __webpack_public_path__ + "img/stadia-home-launch_2x.43897eb0.webp";